import React from "react";
import Teams from "../api/team";
import NavbarS2 from "../components/NavbarS2/NavbarS2";
import PageTitle from "../components/pagetitle/PageTitle";
import Footer from "../components/footer/Footer";
import Scrollbar from "../components/scrollbar/scrollbar";
import { Link } from "react-router-dom";
import logo from '../images/logo.png';

const ClickHandler = () => {
    window.scrollTo(10, 0);
}

const TeamPage = () => {
    return (
        <>
            <NavbarS2 Logo={logo} hclass={'wpo-site-header'} />
            <PageTitle pageTitle={"Our Team"} pagesub={"Team"} />
            <section className="team-page section-padding">
                <div className="container">
                    <div className="row">
                        {Teams.map((team, titem) => (
                            <div className="col-lg-3 col-md-6 col-12" key={titem}>
                                <div className="vol-card">
                                    <div className="image">
                                        <img src={team.timg} alt="" />
                                        <span className="hover-icon"><i className="flaticon-share"></i></span>
                                        <ul>
                                            <li><Link onClick={ClickHandler} to="#"><i className="flaticon-camera"></i></Link></li>
                                            <li><Link onClick={ClickHandler} to="#"><i className="flaticon-facebook-app-symbol"></i></Link></li>
                                            <li><Link onClick={ClickHandler} to="#"><i className="flaticon-linkedin"></i></Link></li>
                                            <li><Link onClick={ClickHandler} to="#"><i className="flaticon-twitter"></i></Link></li>
                                        </ul>
                                    </div>
                                    <div className="text">
                                        <h3><Link onClick={ClickHandler} to={`/volunteer-single/${team.slug}`}>{team.title}</Link></h3>
                                        <span>{team.subtitle}</span>
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
            <Footer />
            <Scrollbar />
        </>
    );
};

export default TeamPage; 